import React from 'react';
import type { Theme } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { CamundaFields } from '@forvalter/utils/CamundaUtils';
import type { Aktivitet } from '@klp/formgenerator/interfaces';
import { useTranslation } from 'react-i18next';

const styles = (theme: Theme) => ({
    textField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.paper,
        },

        '& .MuiFormHelperText-root': {
            textAlign: 'right',
        },
    },
});

type TildelKommentarFieldProps = {
    activity: Aktivitet;
    value: string;
    maxLength: number;
    onChange: (value: string) => void;
};

export const TildelKommentarField: React.FC<TildelKommentarFieldProps> = ({
    activity,
    value,
    maxLength,
    onChange,
}) => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, styles);

    if (!activity?.id) return null;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <TextField
            variant="outlined"
            id={CamundaFields.TILDEL_KOMMENTARER}
            label={t(
                `prosjekt.${CamundaFields.TILDEL_KOMMENTARER}.field.label`,
            )}
            type="text"
            fullWidth={true}
            multiline={true}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{ maxLength }}
            helperText={`${value.length}/${maxLength}`}
            value={value}
            onChange={handleChange}
            className={classes.textField}
        />
    );
};
